import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeVisitReport = gql`
    type AttachmentRef {
        _ref: String
        _type: String
    }
    
    type AttachmentShort {
        id: ID
        name: String
        size: Int
        mimetype: String
    }

    type Attachment {
      id: ID
      name: String
      size: Int
      mimetype: String
      base64String: String
      asset: AttachmentRef
      url: String
    }

    type VisitReport {
      id: ID
      customerNumber: String
      contactName: String
      attendanceStart: String
      attendanceEnd: String
      meetingName: String
      occasions: [VisitReportOccasion]
      mailRecipients: String
      mailSubject: String
      text: String
      creationAt: String
      attendanceAt: String
      attachments: [AttachmentShort]
      attachmentReferences: [Attachment]
      readonly: Boolean
      companyName: String
    }

    type VisitReports {
      total: Int
      items: [VisitReport]
    }

    input VisitReportMutationValues {
      customerNumber: String!
      contactName: String
      attendanceStart: DateTime
      attendanceEnd: DateTime
      meetingName: String!
      occasions: [VisitReportOccasionMutationValues!]!
      mailRecipients: String
      mailSubject: String
      text: String
      attendanceAt: String!
      attachments: [AttachmentMutationValues]
      attachmentReferences: [AttachmentMutationValues]
      deletedAttachmentReferences: [AttachmentMutationValues]
      readonly: Boolean
    }

    type VisitReportOccasion {
      name: String
      label: String
      id: ID
    }

    input VisitReportOccasionMutationValues {
      name: String
      label: String
      id: ID
    }
    
    input AttachmentReference {
        _ref: String
        _type: String
    }

    input AttachmentMutationValues {
        id: ID
        name: String
        mimetype: String
        size: Int
        base64String: String
        asset: AttachmentReference
        url: String
    }

    type Query {
      visitReportsOccasions: [VisitReportOccasion]

      visitReports(
        customerNumber: String = ""
        year: String
        occasionId: ID
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort
        sortWithinLimits: Boolean = false
        lang: String = ""
        cdn: Boolean = false
        page: Int = 0
        searchTerm: String = ""
      ): VisitReports

     
      visitReport(
        lang: String = ""
        cdn: Boolean = false
        id: ID!
      ): VisitReport

      visitReportAttachment(visitReportId: ID!, attachmentId: ID!): Attachment
    }

    type Mutation {
      updateVisitReport(
        lang: String = ""
        cdn: Boolean = false
        id: ID!
        values: VisitReportMutationValues
      ): VisitReport

      createVisitReport(
        lang: String = ""
        values: VisitReportMutationValues
      ): VisitReport

      deleteVisitReport(
        lang: String = ""
        cdn: Boolean = false
        id: ID!
      ): Boolean
    }
`

export { typeVisitReport }

export default typeVisitReport
